<template>
	<div class="xs-12">
		<!-- Label -->
		<div class="flex xs-12 xs-between">
			<label class="fs3 c6 fw6 mb1"
				>{{ label }} <span class="c6--l3">(DD/MM/YYYY)</span></label
			>
			<div
				v-if="shouldDisplayClearButton"
				class="fs3 cu2 cError"
				@click="handleReset"
			>
				{{ $t("clear") }}
			</div>
		</div>

		<!-- Inputs -->
		<div class="flex wrap xs-12">
			<!-- Select type -->
			<div class="flex xs-4 pr1">
				<j-base-select
					:size="size"
					:options="options.date"
					:value="value.type"
					@input="handleTypeChange"
					:allowSelectNothing="false"
				/>
			</div>

			<!-- Before, after input -->
			<div class="xs-8" v-show="value.type === 'before'">
				<j-base-input-text
					name="before"
					:size="size"
					:value="value.before"
					v-validate="'date_format:DD/MM/YYYY'"
					data-vv-validate-on="input|blur"
					:data-vv-as="$t('date')"
					:status="errors.first('before') ? 'error' : null"
					@input="handleInput($event, 'before')"
				/>
			</div>

			<div class="xs-8" v-show="value.type === 'after'">
				<j-base-input-text
					:size="size"
					:value="value.after"
					name="after"
					v-validate="'date_format:DD/MM/YYYY'"
					data-vv-validate-on="input|blur"
					:data-vv-as="$t('date')"
					:status="errors.first('after') ? 'error' : null"
					@input="handleInput($event, 'after')"
				/>
			</div>

			<!-- Between inputs -->
			<div class="flex xs-8" v-show="value.type === 'between'">
				<div class="xs-6 pr1">
					<j-base-input-text
						:size="size"
						:value="value.after"
						name="after2"
						v-validate="'date_format:DD/MM/YYYY'"
						data-vv-validate-on="input|blur"
						:data-vv-as="$t('date')"
						:status="errors.first('after2') ? 'error' : null"
						:placeholder="$t('from')"
						@input="handleInput($event, 'after')"
					/>
				</div>
				<div class="xs-6">
					<j-base-input-text
						:size="size"
						:value="value.before"
						name="before2"
						v-validate="'date_format:DD/MM/YYYY'"
						data-vv-validate-on="input|blur"
						:data-vv-as="$t('date')"
						:status="errors.first('before2') ? 'error' : null"
						@input="handleInput($event, 'before')"
						:placeholder="$t('to')"
					/>
				</div>
			</div>
		</div>

		<!-- Clickable helpers -->
		<div class="pl1 pr1">
			<j-button
				type="tertiary"
				size="small"
				class="mr1"
				@click="prepopulateDate({ type: 'today' })"
				>{{ $t("today") }}</j-button
			>
			<j-button
				type="tertiary"
				size="small"
				class="mr1"
				@click="prepopulateDate({ type: 'lastDays', value: 7 })"
				>{{ $t("last_7_days") }}</j-button
			>
			<j-button
				type="tertiary"
				size="small"
				class="mr1"
				@click="prepopulateDate({ type: 'lastDays', value: 30 })"
				>{{ $t("last_30_days") }}</j-button
			>
			<j-button
				type="tertiary"
				size="small"
				@click="prepopulateDate({ type: 'lastDays', value: 90 })"
				>{{ $t("last_90_days") }}</j-button
			>
		</div>
	</div>
</template>

<script>
import JBaseInputText from "@/components/JBaseInputText/"
import JBaseSelect from "@/components/JBaseSelect/"
import JButton from "@/components/JButton/"
import dayjs from "dayjs"

export default {
	name: "field-date",
	components: { JBaseInputText, JBaseSelect, JButton },

	props: {
		value: {
			type: Object,
			required: true,

			// Value expects object like this
			default: () => ({
				type: "between",
				before: null,
				after: null
			})
		},

		label: {
			type: String,
			required: false,
			default: ""
		},

		size: {
			type: String,
			default: null
		}
	},

	data() {
		return {
			options: {
				date: [
					{ name: this.$t("between"), value: "between" },
					{ name: this.$t("before"), value: "before" },
					{ name: this.$t("after"), value: "after" }
				]
			}
		}
	},

	computed: {
		shouldDisplayClearButton() {
			return false
		}
	},

	methods: {
		handleTypeChange(value) {
			this.$emit("input", {
				...this.value,
				type: value
			})
		},

		handleInput(value, field) {
			this.$emit("input", {
				...this.value,
				[field]: value
			})
		},

		prepopulateDate({ type = null, value = null }) {
			// Calcuale last 7 days, last 30 days from today
			if (type === "lastDays")
				this.$emit("input", {
					type: "between",
					before: dayjs()
						.add(1, "day")
						.format("DD/MM/YYYY"), // today + 1 day
					after: dayjs()
						.subtract(value, "day")
						.format("DD/MM/YYYY")
				})

			if (type === "today")
				this.$emit("input", {
					type: "between",
					before: dayjs()
						.add(1, "day")
						.format("DD/MM/YYYY"),
					after: dayjs().format("DD/MM/YYYY")
				})
		},

		handleReset() {
			this.$emit("input", {
				type: "between",
				before: null,
				after: null
			})
		}
	}
}
</script>
